const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://worldcupfanplanner.com').replace(/\/$/, '');
const SITE_NAME = 'WorldCup Fan Planner';

/** Default on-site author for editorial guides (E-E-A-T). */
export const EDITORIAL_AUTHOR_ORG = {
  type: 'Organization',
  name: SITE_NAME,
  url: `${SITE_URL}/about`,
};

export const getOrganizationSchema = () => {
  const contact = {
    '@type': 'ContactPoint',
    contactType: 'Customer Service',
    availableLanguage: ['English'],
    url: `${SITE_URL}/contact`,
  };
  if (process.env.REACT_APP_CONTACT_EMAIL) {
    contact.email = process.env.REACT_APP_CONTACT_EMAIL;
  }
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/logo192.png`,
    contactPoint: contact,
  };
};

export const getWebSiteSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: SITE_NAME,
  url: SITE_URL,
});

export const getBreadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.url || `${SITE_URL}${item.path || ''}`,
  })),
});

export const getEventSchema = (match) => ({
  '@context': 'https://schema.org',
  '@type': 'SportsEvent',
  name: `${match.team1_name || 'TBD'} vs ${match.team2_name || 'TBD'}`,
  startDate: match.date || new Date().toISOString(),
  location: {
    '@type': 'Place',
    name: match.stadium_name || 'Stadium',
    address: {
      '@type': 'PostalAddress',
      addressLocality: match.stadium_city || match.city || match.stadium_name || '',
      addressCountry: match.stadium_country || '',
    },
  },
  organizer: { '@type': 'Organization', name: 'FIFA' },
});

export const getPlaceSchema = (place) => ({
  '@context': 'https://schema.org',
  '@type': 'Place',
  name: place.name,
  description: place.description,
  address: { '@type': 'PostalAddress', addressLocality: place.city || place.name, addressCountry: place.country },
  geo: place.latitude && place.longitude ? { '@type': 'GeoCoordinates', latitude: place.latitude, longitude: place.longitude } : undefined,
});

function authorToSchemaNode(author) {
  if (!author) {
    return { '@type': 'Organization', name: SITE_NAME, url: SITE_URL };
  }
  if (author.type === 'Person') {
    return {
      '@type': 'Person',
      name: author.name,
      ...(author.url ? { url: author.url } : {}),
    };
  }
  return {
    '@type': 'Organization',
    name: author.name,
    ...(author.url ? { url: author.url } : {}),
  };
}

export const getArticleSchema = ({
  headline,
  description,
  datePublished = '2026-01-01',
  dateModified,
  author = EDITORIAL_AUTHOR_ORG,
  publisherName = SITE_NAME,
}) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline,
  description,
  datePublished,
  ...(dateModified ? { dateModified } : {}),
  author: authorToSchemaNode(author),
  publisher: {
    '@type': 'Organization',
    name: publisherName,
    logo: { '@type': 'ImageObject', url: `${SITE_URL}/logo192.png` },
  },
});

export const getFAQSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map(({ question, answer }) => ({
    '@type': 'Question',
    name: question,
    acceptedAnswer: { '@type': 'Answer', text: answer },
  })),
});
